import {uniq} from 'lodash-es';
import {useState} from 'react';
import {toast} from 'react-toastify';

import type {
  NotifyModalData,
  NotifyModalProps,
} from '@/screens/Processor/Metrics/NotifyModal';
import NotifyModal from '@/screens/Processor/Metrics/NotifyModal';
import type {Metrics, MetricsData} from '@/screens/Processor/Metrics/types';
import {processorService} from '@/services/processorService';
import {getResponseMessage} from '@/utils/errorMessage';

import SuccessPerCorridorTable from './PerCorridorTable';

const Corridor = ({metrics, data}: {metrics: Metrics; data: MetricsData[]}) => {
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [notifyModalProps, setNotifyModalProps] = useState<
    Pick<
      NotifyModalProps,
      | 'message'
      | 'selectedProcessor'
      | 'selectedCorridorPair'
      | 'selectedPaymentInstrument'
    >
  >({
    message: '',
    selectedProcessor: '',
    selectedCorridorPair: '',
    selectedPaymentInstrument: '',
  });

  const createNotifyModal = async (data: NotifyModalData) => {
    try {
      await processorService.createDowntimeNotification(data);
      setShowNotifyModal(false);
      toast.success('Notification created');
    } catch (error) {
      toast.error(getResponseMessage(error) || 'Error creating notification');
    }
  };

  // Get unique processors and corridors from data
  const processors = uniq(data.map((item) => item.processor));
  const corridorPairs = uniq(data.map((item) => item.corridor_pair));
  const paymentInstruments = uniq(data.map((item) => item.payment_instrument));

  return (
    <section className="pt-5 md:pt-5">
      <h1 className="text-lg font-semibold mb-2">
        Success Rate % per Corridor
      </h1>

      <SuccessPerCorridorTable
        metrics={metrics}
        data={data}
        setShowNotifyModal={setShowNotifyModal}
        setNotifyModalProps={setNotifyModalProps}
      />

      <NotifyModal
        {...notifyModalProps}
        processors={processors}
        corridorPairs={corridorPairs}
        paymentInstruments={paymentInstruments}
        onSubmit={createNotifyModal}
        onClose={() => setShowNotifyModal(false)}
        isOpen={showNotifyModal}
      />
    </section>
  );
};

export default Corridor;
